import { getElements, addClass } from '../helpers/functions';
export default () => {
  const $frames = getElements('.frame');
  $frames.forEach($frame => {
    const reveal = () => {
      addClass($frame, '__revealed');
      // Remove listeners once revealed
      $frame.removeEventListener('mouseenter', reveal);
      $frame.removeEventListener('focusin', reveal);
    };
    $frame.addEventListener('mouseenter', reveal);
    $frame.addEventListener('focusin', reveal);
  });
};